<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { RouteLocationRaw } from 'vue-router'
import AffectedElementType from '../../../../../Constants/AffectedElementType.ts'
import { Routes } from '../../../../../Constants/Routes.ts'
import type { AffectedElement } from '../../../../../Types/restructuring'
import PageLink from '../../UI/PageLink.vue'

export interface AffectedElementListItemProps {
  element: AffectedElement
}

const props = defineProps<AffectedElementListItemProps>()

const { t, d } = useI18n()

const targetLink = computed<RouteLocationRaw | null>(() => {
  if (props.element.deleted) {
    return null
  }

  if (props.element.type === AffectedElementType.CONTRACT) {
    return { name: Routes.CONTRACT_VIEW, params: { id: props.element.id } }
  } else if (props.element.type === AffectedElementType.SIMULATION) {
    return { name: Routes.SIMULATION_VIEW, params: { id: props.element.id } }
  }

  return null
})
</script>

<template>
  <tr>
    <td data-test="affected-element-list-item-type">
      {{ t(`module.${element.type}`) }}
    </td>
    <td data-test="affected-element-list-item-creation-date">
      {{ d(element.createdAt.toString(), 'datetime') }}
    </td>
    <td data-test="affected-element-list-item-cancellation-date">
      {{ element.canceledAt ? d(element.canceledAt?.toString(), 'datetime') : '-' }}
    </td>
    <td :class="{ 'line-through': element.canceled || element.deleted }" data-test="affected-element-list-item-name">
      <template v-if="element.deleted || !targetLink">{{ element.label }}</template>
      <PageLink v-else :to="targetLink" external>{{ element.label }}</PageLink>
    </td>
  </tr>
</template>
